import { FC } from 'react';
import { Control } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';
import { PartnerCreateEditDto } from 'src/types';
import { Field, FormCard } from '../../Form/FormCard';

interface Props {
    control: Control<PartnerCreateEditDto, object>;
}

const fields: (Field<PartnerCreateEditDto> & TextFieldProps)[] = [
    {
        name: 'commissionPaymentInfo.bankAccount',
        label: 'Account Number',
        inputProps: {
            maxLength: 34,
            // TODO: disabled because of Safari autofill, fix later
            // type: 'password',
            autoComplete: 'cc-number'
        },
        xs: 6
    },
    {
        name: 'commissionPaymentInfo.bankRouting',
        label: 'Routing / ABA Number',
        inputProps: {
            maxLength: 9
            // TODO: disabled because of Safari autofill, fix later
            // type: 'password',
            // autoComplete: 'current-password'
        },
        xs: 6
    },
    {
        name: 'commissionPaymentInfo.accountHolder',
        label: 'Legal Name',
        required: true,
        inputProps: {
            maxLength: 26
        },
        xs: 6
    }
];

export const CommissionPaymentInfoForm: FC<Props> = ({ control }) => (
    <FormCard
        control={control}
        fields={fields}
        title="Commission Payment Information"
        description="The following bank information must be entered correctly in order to deposit earner commission directly into the partner’s account."
    />
);
